import { Tooltip } from '@zoom/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { translateScheduleElementName } from '../../components/MySchedule/transformData';
import { ScheduleElement } from '../../graphql/components';
import { recordBy } from '../../utils/array';
import { ScheduledActivityLabel } from './ScheduledActivityLabel';

type AdherenceSettingScheduleActivitiesProps = {
  scheduleActivityIds: string[];
  scheduleElements: ScheduleElement[];
};

export const AdherenceSettingScheduleActivities: React.FC<AdherenceSettingScheduleActivitiesProps> = ({
  scheduleActivityIds,
  scheduleElements,
}) => {
  const { t } = useTranslation();

  const scheduleElementsRecord = recordBy(scheduleElements, 'id');

  return (
    <div className="mt-n1 ml-n1">
      {scheduleActivityIds.map((elementId) => {
        const element = scheduleElementsRecord[elementId];

        // Remember to check Record objects, TS v4.1 should imply `undefined`
        if (element === undefined) {
          return null;
        }

        const elementName = translateScheduleElementName(t, element);

        return (
          <Tooltip key={elementId} message={elementName} placement="bottom" targetClassName="d-inline-block ml-1 mt-1">
            <ScheduledActivityLabel
              key={elementId}
              label={elementName.slice(0, 2)}
              element={element}
              value={elementId}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};
